<template>
  <div class="contract-query-and-verify-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="计算方式" prop="method">
            <el-select
              v-model="formDate.method"
              placeholder="请选择计算方式"
              clearable
              disabled
              class="auto-width"
              value-key="label"
            >
              <el-option
                v-for="item in methodOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="链下计算结果证明" prop="proofa2">
            <el-input v-model="formDate.proofa2" placeholder="请输入链下计算结果证明"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="handleContractQueryAndVerify()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 140
  },
  data() {
    return {
      formDate: {
        method: null,
        chainId: '',
        userId: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID),
        proofa2: ''
      },
      methodOption: [
        {
          label: '承诺加数值',
          value: 1
        },
        {
          label: '承诺加承诺',
          value: 2
        },
        {
          label: '承诺减数值',
          value: 3
        },
        {
          label: '承诺减承诺',
          value: 4
        },
        {
          label: '承诺乘数值',
          value: 5
        }
      ],
      editRules: {
        proofa2: [{ required: true, message: '请输入链下计算结果证明', trigger: 'blur' }]
      },
      adaptationVars: {
        formLabelWidth: 140
      }
    }
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.formDate.chainId = val
      }
    }
  },
  mounted() {
    this.formDate.chainId = this.$store.state.computing.chainId
    this.formDate.method = parseInt(localStorage.getItem('provemethod')) || null // 设置初始值
  },
  methods: {
    handleContractQueryAndVerify() {
      this.$refs.formDate.validate().then(valid => {
        if (valid) {
          this.$apis.bulletproofs.contractQueryAndVerify(this.formDate).then(res => {
            if (res) {
              this.formDate.result = res.data.result
              this.$message.success('验证进行中!')
            }
          })
        }
      })
    },
    methodChange() {}
  }
}
</script>

<style scoped lang="scss">
.contract-query-and-verify-wrapper {
  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}
</style>
